import { LegalPageLayout, LegalSection } from '../components/LegalPageLayout';
import { LEGAL_SERVICE } from '../legal.constants';

export function LegalNoticesPage() {
  return (
    <LegalPageLayout title="Mentions légales">
      <LegalSection title="Éditeur">
        <p>
          <strong>{LEGAL_SERVICE.name}</strong> est édité par{' '}
          <strong>{LEGAL_SERVICE.publisher}</strong>, nom commercial{' '}
          {LEGAL_SERVICE.publisherTradeName}.
        </p>
        <dl className="grid gap-x-8 gap-y-3 text-sm sm:grid-cols-2">
          <div>
            <dt className="text-neutral-500">Forme et capital</dt>
            <dd className="font-medium text-neutral-950">
              {LEGAL_SERVICE.legalForm} au capital de{' '}
              {LEGAL_SERVICE.shareCapital}
            </dd>
          </div>
          <div>
            <dt className="text-neutral-500">Siège social</dt>
            <dd className="font-medium text-neutral-950">
              {LEGAL_SERVICE.registeredOffice}
            </dd>
          </div>
          <div>
            <dt className="text-neutral-500">Immatriculation</dt>
            <dd className="font-medium text-neutral-950">
              {LEGAL_SERVICE.registration}
            </dd>
          </div>
          <div>
            <dt className="text-neutral-500">SIRET</dt>
            <dd className="font-medium text-neutral-950">
              {LEGAL_SERVICE.siret}
            </dd>
          </div>
          <div>
            <dt className="text-neutral-500">TVA intracommunautaire</dt>
            <dd className="font-medium text-neutral-950">
              {LEGAL_SERVICE.vatNumber}
            </dd>
          </div>
          <div>
            <dt className="text-neutral-500">Directeur de la publication</dt>
            <dd className="font-medium text-neutral-950">
              {LEGAL_SERVICE.publicationDirector}
            </dd>
          </div>
        </dl>
      </LegalSection>

      <LegalSection title="Hébergement">
        <p>
          Le site public utilise Vercel ; l&apos;application et l&apos;API
          utilisent une infrastructure du réseau Hostinger. Cette observation
          technique ne suffit pas à établir l&apos;identité des entités
          contractées par l&apos;éditeur.
        </p>
      </LegalSection>

      <LegalSection title="Propriété intellectuelle">
        <p>
          Les logiciels, textes, éléments graphiques, marques et autres contenus
          accessibles dans le service restent protégés par les droits de leurs
          titulaires respectifs. Leur reproduction ou leur réutilisation suppose
          l&apos;autorisation du titulaire concerné, sauf exception prévue par
          la loi.
        </p>
      </LegalSection>

      <LegalSection title="Responsabilité">
        <p>
          Le service fournit des outils de paie, de gestion RH et de BDESE. Il
          ne remplace ni les vérifications professionnelles de
          l&apos;utilisateur ni les obligations qui incombent à
          l&apos;employeur. Les engagements de disponibilité, d&apos;assistance
          et de responsabilité applicables à un client sont ceux de son contrat.
        </p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>
          Pour une question relative au service, aux présentes mentions ou aux
          données personnelles :{' '}
          <a
            href={`mailto:${LEGAL_SERVICE.contactEmail}`}
            className="font-medium underline decoration-neutral-300 underline-offset-4 hover:text-neutral-950"
          >
            {LEGAL_SERVICE.contactEmail}
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="Droit applicable">
        <p>
          Le service et les présentes mentions sont soumis au droit français. Le
          contrat conclu avec le client précise, le cas échéant, les règles de
          règlement amiable et la juridiction compétente. Aucun dispositif de
          médiation n&apos;est affirmé ici sans engagement contractuel vérifié.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
